export default __webpack_public_path__ + "static/media/rewards.e7a00f74.svg";